import { auth } from '../FirebaseConfig'
import { jwtDecode, type JwtPayload } from 'jwt-decode'

interface AppJwtPayload extends JwtPayload {
  'https://hasura.io/jwt/claims': string
}

export const getToken = () => localStorage.getItem('token')
export const removeToken = () => localStorage.removeItem('token')

export async function refreshIdToken() {
  const token = await waitForCustomClaims()
  if (token === undefined) {
    throw new Error('Failed to get ID token')
  }
  localStorage.setItem('token', token)
  return token
}

async function waitForCustomClaims(maxRetries = 5, delay = 2000) {
  let retries = 0
  while (retries < maxRetries) {
    try {
      const token = await auth.currentUser?.getIdToken(true)
      const decodedToken = jwtDecode<AppJwtPayload>(token ?? '{}')
      const claims = decodedToken['https://hasura.io/jwt/claims']
      if (claims) {
        return token
      }
    } catch (error) {
      console.warn('can not decoding token:', error)
    }
    await new Promise((resolve) => setTimeout(resolve, delay))
    retries++
  }
  return undefined
}
